import types from './types'

export const loadOpportunity = (opportunityId) => ({ type: types.OPPORTUNITY_LOAD_ATTEMPT, opportunityId})
export const loadOpportunitySuccess = (data) => ({ type: types.OPPORTUNITY_LOAD_SUCCESS, data })
export const loadOpportunityFailure = (message, code) => ({ type: types.OPPORTUNITY_LOAD_FAILURE, message, code })

export const addOpportunity = (opportunity) => ({ type: types.OPPORTUNITY_ADD_ATTEMPT, opportunity})
export const addOpportunitySuccess = (data) => ({ type: types.OPPORTUNITY_ADD_SUCCESS, data })
export const addOpportunityFailure = (message, code) => ({ type: types.OPPORTUNITY_ADD_FAILURE, message, code })

export const updateOpportunity = (opportunity) => ({ type: types.OPPORTUNITY_UPDATE_ATTEMPT, opportunity})
export const updateOpportunitySuccess = (data) => ({ type: types.OPPORTUNITY_UPDATE_SUCCESS, data })
export const updateOpportunityFailure = (message, code) => ({ type: types.OPPORTUNITY_UPDATE_FAILURE, message, code })

export const updateOpportunityFilters = (filters) => ({ type: types.OPPORTUNITY_UPDATE_FILTERS, filters})

export const reloadOpportunityOnBoard = (opportunity) => ({ type: types.RELOAD_OPPORTUNITY_ON_BOARD, opportunity})
